<template>
    <div class="container" v-cloak>
        <div class="title f">
            <span>实时数据</span>
            <span>时区(UTC+08:00)  {{periodTotal.createDate}}</span>
        </div>
        <div class="form f bg-white">
            <div style="line-height: 40px">统计日期：</div>
            <el-date-picker
                v-model="period"
                type="date"
                placeholder="统计日期"
                style="margin-right: 10px"
                @change="dateChange"
                value-format="yyyy-MM-dd"
                :clearable="false"
                :picker-options="{disabledDate}">
            </el-date-picker>
            <div style="line-height: 40px">比较日期：</div>
            <el-date-picker
                v-model="compare"
                type="date"
                placeholder="比较日期"
                style="margin-right: 10px"
                @change="dateChange"
                value-format="yyyy-MM-dd"
                :clearable="false"
                :picker-options="{disabledDate}">
            </el-date-picker>
        </div>
        <div class="numerical f-b">
            <div class="number" :class="{selectedValue: selectedValue === 'orderAmount'}" @click="selectedValueChange('orderAmount')">
                <div>
                    成交额
                    <el-tooltip class="item" effect="dark" content="在时间时间内的总成交金额" placement="top">
                        <i class="el-icon-question"></i>
                    </el-tooltip>
                </div>
                <div>$ {{ periodTotal.orderAmount }}</div>
            </div>
            <div class="number" :class="{selectedValue: selectedValue === 'visitorQty'}" @click="selectedValueChange('visitorQty')">
                <div>
                    访客数
                    <el-tooltip class="item" effect="dark" content="在统计时间内访问官网的用户记录数量（包含游客）" placement="top">
                        <i class="el-icon-question"></i>
                    </el-tooltip>
                </div>
                <div>{{ periodTotal.visitorQty }}</div>
            </div>
            <div class="number" :class="{selectedValue: selectedValue === 'registerQty'}" @click="selectedValueChange('registerQty')">
                <div>
                    注册数量
                    <el-tooltip class="item" effect="dark" content="在统计时间内注册kaka的用户数" placement="top">
                        <i class="el-icon-question"></i>
                    </el-tooltip>
                </div>
                <div>{{ periodTotal.registerQty }}</div>
            </div>
            <div class="number" :class="{selectedValue: selectedValue === 'registerConversionRate'}" @click="selectedValueChange('registerConversionRate')">
                <div>
                    注册转换率
                    <el-tooltip class="item" effect="dark" content="注册数和访问数的占比  公式：注册转化率= 注册数量/访客数*100%" placement="top">
                        <i class="el-icon-question"></i>
                    </el-tooltip>
                </div>
                <div>{{ periodTotal.registerConversionRate | toPercentage }}</div>
            </div>
        </div>
        <div class="numerical f-b">
            <div class="number" :class="{selectedValue: selectedValue === 'wishQty'}" @click="selectedValueChange('wishQty')">
                <div>
                    添加心愿单
                    <el-tooltip class="item" effect="dark" content="在统计时间添加心愿单的所有产品总数" placement="top">
                        <i class="el-icon-question"></i>
                    </el-tooltip>
                </div>
                <div>{{ periodTotal.wishQty }}</div>
            </div>
            <div class="number" :class="{selectedValue: selectedValue === 'cartQty'}" @click="selectedValueChange('cartQty')">
                <div>
                    添加购物车
                    <el-tooltip class="item" effect="dark" content="在统计时间添加购物车的所有产品总数" placement="top">
                        <i class="el-icon-question"></i>
                    </el-tooltip>
                </div>
                <div>{{ periodTotal.cartQty }}</div>
            </div>
            <div class="number" :class="{selectedValue: selectedValue === 'createOrderQty'}" @click="selectedValueChange('createOrderQty')">
                <div>
                    创建订单
                    <el-tooltip class="item" effect="dark" content="在统计时间内创建的所有订单（含未付款、已取消）" placement="top">
                        <i class="el-icon-question"></i>
                    </el-tooltip>
                </div>
                <div>{{ periodTotal.createOrderQty }}</div>
            </div>
            <div class="number" :class="{selectedValue: selectedValue === 'paymentOrderQty'}" @click="selectedValueChange('paymentOrderQty')">
                <div>
                    已付款订单
                    <el-tooltip class="item" effect="dark" content="在统计时间（PT）内总的所有注册用户创建的订单已付款的数量" placement="top">
                        <i class="el-icon-question"></i>
                    </el-tooltip>
                </div>
                <div>{{ periodTotal.paymentOrderQty }}</div>
            </div>
        </div>
        <div id="constantlyDataChart"></div>
    </div>
</template>

<script>
import API from '@/api'
import moment from 'moment'

export default {
    name: 'constantlyData',
    components: {
    },
    filters: {
        toPercentage(value) {
            let final
            if(value === undefined) final = 0
            else final = `${(value*100).toFixed(2)}%`
            return final
        }
    },
    data() {
        return {
            period: undefined,
            compare: undefined,
            searchParams: {
                startPeriod: undefined,
                endPeriod: undefined
            },
            periodTotal: {
                orderAmount: undefined,
                visitorQty: undefined,
                registerQty: undefined,
                wishQty: undefined,
                cartQty: undefined,
                createOrderQty: undefined,
                paymentOrderQty: undefined,
                orderConversionRate: undefined,
                creaeDate: undefined,
                registerConversionRate: undefined
            },
            selectedValue: 'orderAmount',
            chartData: {},
            createDate: 0
        }
    },
    async created() {
        this.period = moment().format('YYYY-MM-DD')
        this.compare = moment().subtract(1,'months').format('YYYY-MM-DD')
        this.getData()
    },
    methods: {
        dateChange() {
            this.getData()
        },
        async getData() {
            try {
                const params = {
                    period: parseInt(this.period.split('-').join('')),
                    compare: parseInt(this.compare.split('-').join(''))
                }
                const res = await API.constantlyDataBoardHoursReport(params)
                res.data.periodList.forEach(e=>e.registerConversionRate = (e.registerConversionRate * 100).toFixed(2))
                res.data.compareList.forEach(e=>e.registerConversionRate = (e.registerConversionRate * 100).toFixed(2))
                this.chartData = res.data
                this.periodTotal = res.data.periodTotal
                this.periodTotal.createDate = moment(this.periodTotal.createDate).format('YYYY-MM-DD HH:mm:ss')
                this.drawChart(res.data)
            } catch (error) {
                console.log(error)
            }
        },
        drawChart(data) {
            this.$nextTick(()=>{
                this.myChart = this.$echart.init(document.getElementById('constantlyDataChart'))
                const option = this.generateOption(data)
                this.myChart.setOption(option)
            })
        },
        generateOption(data) {
            let option;
            const point = {
                orderAmount: '成交额',
                visitorQty: '访客数',
                registerQty: '注册数量',
                wishQty: '添加心愿单',
                cartQty: '添加购物车',
                createOrderQty: '创建订单',
                paymentOrderQty: '已付款订单',
                orderConversionRate: '订单转换率',
                registerConversionRate: '注册转换率'
            }
            data.periodList = this.dataLengthSupplement(data.periodList)
            data.compareList = this.dataLengthSupplement(data.compareList)
            option = {
                title: { text: `${point[this.selectedValue]}实时数据`},
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: [ this.period, this.compare]
                },
                toolbox: {
                    show: true,
                    feature: {
                        saveAsImage: { show: true }
                        }
                },
                // formatter: function (params) {
                //     console.log(params); // 当我们想要自定义提示框内容时，可以先将鼠标悬浮的数据打印出来，然后根据需求提取出来即可
                //     let firstParams = params[0];
                //     let sndParams = params[1];
                //     return `${firstParams.data} </br> ${sndParams.data}`;
                // },
                calculable: true,
                xAxis: [
                    {
                        type: 'category',
                        data: data.periodList.map(e=>e.hours)
                    }
                ],
                yAxis: [
                    {
                        type: 'value'
                    }
                ],
                series: [
                    {
                        name: this.period,
                        type: 'bar',
                        data: data.periodList.map(e=>e[this.selectedValue]),
                        markPoint: {
                            data: [
                                { type: 'max', name: 'Max' },
                                { type: 'min', name: 'Min' }
                            ]
                        }
                    },
                    {
                        name: this.compare,
                        type: 'bar',
                        data: data.compareList.map(e=>e[this.selectedValue]),
                        markPoint: {
                            data: [
                                { type: 'max', name: 'Max' },
                                { type: 'min', name: 'Min' }
                            ]
                        }
                    }
                ]
            }
            return option
        },
        selectedValueChange(value) {
            if(value !== this.selectedValue) {
                this.selectedValue = value
                this.drawChart(this.chartData)
            }
        },
        disabledDate(time) {
            return time.getTime() > new Date().getTime()
        },
        dataLengthSupplement(data) {
            let arr = []
            arr.length = 23
            arr.fill(null)
            data = data.concat(arr).slice(0, 24)
            data = data.map((e, i)=>{
                if(!e) {
                    return {hours: i}
                }
                return e
            })
            return data
        }
    }
}
</script>

<style lang="scss">
[v-cload] {
    display: none;
}
.container {
    min-width: 1200px;
    padding-bottom: 40px;
    .form {
        margin-bottom: 10px;
        padding: 4px 20px;
    }
    .title {
        height: 20px;
        line-height: 20px;
        margin: 20px;
        >span:first-of-type {
            font-size: 20px;
            font-weight: bold;
            margin-right: 8px;
        }
        >span:nth-of-type(2) {
            font-size: 12px;
        }
    }
    .ranking_group {
        margin-bottom: 20px;
    }
    .numerical {
        margin-bottom: 10px;
        .number {
            margin-right: 20px;
            background-color: #fff;
            padding: 30px 40px;
            width: 24%;
            border: 1px solid transparent;
            box-shadow: 5px 5px 5px #ebeef5;
            border-radius: 5px;
            transition: all .5s;
            >div:nth-of-type(2) {
                font-weight: bold;
                margin-top: 6px;
            }
        }
        >.number:last-of-type {
            margin-right: 0px;
        }
        .number:hover {
            border-color: red;
            opacity: .7;
        }
        .selectedValue {
            border-color: #99c41c;
        }
    }
    #constantlyDataChart{
        width: 100%;
        height: 700px;
        background-color: #fff;
    }
}
</style>